import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { NAV_ANCHORS, NAV_ANCHORS_BY_PERSONA } from "./personaConfig";

export function JumpNav({ persona, onExpandAll, onCollapseAll }) {
  return (
    <div className="cre-glass border border-white/10 rounded-sm p-3 flex flex-wrap items-center gap-2 sticky top-14 z-30">
      <span className="cre-overline mr-2">Jump to</span>
      <div className="flex flex-wrap gap-1" data-testid="nav-anchors">
        {(NAV_ANCHORS_BY_PERSONA[persona] || NAV_ANCHORS).map(
          ([anchor, label]) => (
            <a
              key={anchor}
              href={`#${anchor}`}
              data-testid={`anchor-${anchor}`}
              className="text-[11px] font-mono uppercase tracking-widest border border-white/10 hover:border-white/30 px-2 py-1 rounded-sm text-zinc-400 hover:text-zinc-100 transition-colors"
            >
              {label}
            </a>
          )
        )}
      </div>
      <div className="ml-auto flex items-center gap-1">
        <button
          onClick={onExpandAll}
          data-testid="expand-all"
          className="text-[11px] font-mono uppercase tracking-widest border border-white/10 hover:border-white/30 px-2 py-1 rounded-sm text-zinc-400 hover:text-zinc-100"
        >
          <ChevronsDownUp className="inline h-3 w-3 mr-1 -mt-0.5" />
          Expand all
        </button>
        <button
          onClick={onCollapseAll}
          data-testid="collapse-all"
          className="text-[11px] font-mono uppercase tracking-widest border border-white/10 hover:border-white/30 px-2 py-1 rounded-sm text-zinc-400 hover:text-zinc-100"
        >
          <ChevronsUpDown className="inline h-3 w-3 mr-1 -mt-0.5" />
          Collapse all
        </button>
      </div>
    </div>
  );
}
